// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-menu-bar[data-v-639e7e88]{background-color:#fff;border-bottom:1px solid #e0e6e8;box-shadow:none;display:flex;height:4rem;line-height:4rem;position:relative}.x-menu-bar.transparent[data-v-639e7e88]{background-color:transparent;border-bottom:1px solid #d7dfe1;box-shadow:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
